import { IPage } from '@types'
import Layout from 'components/layouts/Layout'
import { generateStaticProps } from 'lib/generateStaticProps'
import { isAbsent, isPresent } from 'lib/utils'
import Alerts from 'components/common/Alerts'
import { useRouter } from 'next/router'
import {
  GetStaticPaths,
  GetStaticPropsContext,
  InferGetStaticPropsType,
} from 'next'

export let getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export let getStaticProps = async (ctx: GetStaticPropsContext) =>
  await generateStaticProps(ctx)

export type AnyPageProps = InferGetStaticPropsType<
  typeof getStaticProps
>

let AnyPage: IPage<AnyPageProps> = ({ content }) => {
  const router = useRouter()
  const path = router.asPath.slice(1)

  if (isAbsent(content)) return null

  return (
    <div className='custom-px mb-12 bg-white flex-grow'>
      <Alerts type={`page.${path}`} />
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  )
}

AnyPage.getLayout = (page: { props: AnyPageProps }) => (
  <Layout
    menus={page.props?.menus}
    index={isPresent(page.props.content)}
    title={page.props?.title}
    description={page.props?.description}
    keywords={page.props?.keywords}
  >
    {page}
  </Layout>
)

export default AnyPage
